'use strict';

// Libraries
var _ = require('underscore');
var Backbone = require('backbone');

module.exports = _.extend({}, Backbone.Events);